export const getTaskFilesAdapter = (payload) => {
  return payload.map((item) => ({
    fileName: item.NombreArchivo,
    url: `${item.IdProyecto}/${item.IdActividad}/${item.NombreArchivo}`,
    fileId: item.Id
  }));
};
